import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';
import { getPOExceptionMgmtBuyerTablefilterEndpoint } from '../../common/endpoints';

export const getPOExceptionMgmtBuyerFilter = createApi("getPOExceptionMgmtBuyerTablefilter","POST");

const POExceptionMgmtBuyerFilterSlice = createSlice({
  name: 'POExceptionMgmtBuyerFilterSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPOExceptionMgmtBuyerFilter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPOExceptionMgmtBuyerFilter.fulfilled, (state, action) => {
        state.loading = false;
        try {
          const payload = action.payload || {};
          const normalizeItem = (item) => {
            if (item === null || item === undefined) return { title: String(item), value: item };
            if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') {
              const s = String(item);
              return { title: s, value: s };
            }
            if (typeof item === 'object') {
              return { title: JSON.stringify(item), value: JSON.stringify(item) };
            }
            return { title: String(item), value: item };
          };

          const transformed = {};
          Object.keys(payload).forEach((key) => {
            try {
              const list = Array.isArray(payload[key]) ? payload[key] : [];
              transformed[key] = list.map(normalizeItem);
            } catch (e) {
              transformed[key] = [];
            }
          });
          state.data = transformed;
        } catch (e) {
          state.data = {};
        }
      })
      .addCase(getPOExceptionMgmtBuyerFilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const selectDropdownOptionsData = (state) => state.getPOExceptionMgmtBuyerFilter?.data;
export const selectDropdownOptionsLoading = (state) => state.getPOExceptionMgmtBuyerFilter?.loading;

export default POExceptionMgmtBuyerFilterSlice.reducer;